<script lang="ts">
	import { rowActions } from '../index.js'

	interface Props {
		row: Record<string, string>
		key: string
		onActionHandler: ((action: rowActions, id: string) => void) | null
	}

	let { row, key, onActionHandler = null }: Props = $props()

	const actions = $derived(row.actions || Array.from(Object.values(rowActions))) as rowActions[]

	const handleClick = (action: rowActions, id: string) => {
		onActionHandler?.(action, id)
	}
</script>

<div class="label-container">
	{#each actions as action}
		<button
			class="label"
			onclick={(e) => {
				e.stopPropagation()
				handleClick(action, row.id)
			}}
		>
			{action}
		</button>
	{/each}
</div>

<style>
	.label-container {
		display: flex;
		align-items: center;
		gap: 16px;
	}
	.label {
		text-transform: capitalize;
		text-decoration: underline;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;
		text-decoration-thickness: auto;
		text-underline-offset: auto;
		font-family: 'inter', sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
		color: #007acc;
		white-space: nowrap;
	}
</style>
